import ReactMarkdown, { type Components } from "react-markdown";

import { AuthorTypeEnum } from "@fitness-app/data-models/entities/AuthorTypeEnum";
import { type ClientNote } from "@fitness-app/data-models/entities/ClientNote";

const components: Components = {
  p: ({ children }) => <p className="mb-3 whitespace-pre-wrap last:mb-0">{children}</p>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
};

/**
 * Notes written by the system are Markdown (TRE-2215: form answers in bold). Notes typed by
 * people stay plain text: rendering them as Markdown would turn their `*`, `-` and `1.` into
 * formatting they never meant.
 */
export const ClientNoteContent = ({ note }: { note: Pick<ClientNote, "content" | "authorType"> }) =>
  note.authorType === AuthorTypeEnum.System ? (
    <ReactMarkdown components={components}>{note.content}</ReactMarkdown>
  ) : (
    <p className="whitespace-pre-wrap">{note.content}</p>
  );
